import './index.css';
import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Amplify, Auth } from "aws-amplify";
import awsmobile from "./aws-exports.js";
import { H } from "highlight.run";
import { ErrorBoundary } from "@highlight-run/react";
import FullStory from "react-fullstory";

Amplify.configure(awsmobile);
Auth.configure(awsmobile);

const root = ReactDOM.createRoot(document.getElementById("root"));
// const ORG_ID = "18XA3X";

root.render(
  <React.StrictMode>
    {/* <ErrorBoundary> */}
    <App>{/* <FullStory org={ORG_ID} /> */}</App>
    {/* </ErrorBoundary> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
